module.exports = __webpack_public_path__ + "static/media/colheitadeira.f3a570dc.svg";